import { render } from "./Trackers.vue?vue&type=template&id=3c0bf2da"
import script from "./Trackers.vue?vue&type=script&lang=js"
export * from "./Trackers.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__